export const POST_USERADDRESS_REQUEST = "POST_USERADDRESS_REQUEST"
export const POST_USERADDRESS_SUCCESS = "POST_USERADDRESS_SUCCESS"
export const POST_USERADDRESS_FAILURE = "POST_USERADDRESS_FAILURE"

export const GET_USERADDRESS_REQUEST = "GET_USERADDRESS_REQUEST"
export const GET_USERADDRESS_SUCCESS = "GET_USERADDRESS_SUCCESS"
export const GET_USERADDRESS_FAILURE = "GET_USERADDRESS_FAILURE"



